// 通信メソッド定義 
export const MethodType = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
} as const;

// エラーコード
export const ErrorCode = {
    SUCCCESS: 0,
} as const;

// 共通レスポンス型
export type ErrorResponseType = {
    httpStatusCode: number,
    errorCode: typeof ErrorCode[keyof typeof ErrorCode],
    errorHttpStatus: boolean,
    errorMessage: string,
}

// 共通リクエスト型
export interface RequestType{
}

// 共通レスポンス型
export type ResponseType = ErrorResponseType & {
}

// API基底クラス
export default abstract class BaseApi<Request extends RequestType, Response extends ResponseType> {
    // 通信メソッド 
    public method: typeof MethodType[keyof typeof MethodType] = 'POST';
    // リクエストURL 
    abstract url: string;
    // リクエストパラメーター 
    abstract request: Request;
    // FormDataで送るかどうか 
    abstract isSendAsFormData: boolean;
    /**
     * レスポンスパース処理
     * 日付型の情報などを修正するなどするよ！
     * @param data レスポンスデータ
     * @returns レスポンス
     */
    abstract parseResponse(data: any): Response;
}

export abstract class Api<Request extends RequestType, Response extends ResponseType> extends BaseApi<Request, Response> {
    // FormDataで送るかどうか 
    public isSendAsFormData: boolean = false;
    // コンストラクター
    constructor(request: Request) {
        super();
    }
    /**
     * レスポンスパース処理
     * 日付型の情報などを修正するなどするよ！
     * @param data レスポンスデータ
     * @returns レスポンス
     */
    public parseResponse(data: any): Response {
        return data;
    };
}